module.exports = __webpack_public_path__ + "media/images/flags/tk-67a6414c174b5a74f382a71a66aea816.svg";